import { render, staticRenderFns } from "./DettagliGestione.vue?vue&type=template&id=326621eb"
import script from "./DettagliGestione.vue?vue&type=script&lang=js"
export * from "./DettagliGestione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports